var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSpeedometer = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M29.333 16c0 7.364-5.97 13.333-13.333 13.333-7.364 0-13.334-5.97-13.334-13.333m26.667 0c0-7.364-5.97-13.334-13.333-13.334M29.333 16H26M2.666 16C2.666 8.636 8.636 2.666 16 2.666M2.666 16H6M16 2.666V6m9.438.667L18 14m7.438 11.438-.272-.272c-.922-.922-1.384-1.384-1.922-1.714a5.332 5.332 0 0 0-1.542-.638c-.613-.148-1.266-.148-2.57-.148h-6.264c-1.305 0-1.957 0-2.57.148a5.335 5.335 0 0 0-1.542.639c-.539.33-1 .79-1.922 1.713l-.272.272m0-18.771 2.315 2.315M18.667 16a2.667 2.667 0 1 1-5.334 0 2.667 2.667 0 0 1 5.333 0Z",
  stroke: "currentColor",
  strokeWidth: 2.667,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgSpeedometer;